export default __webpack_public_path__ + "static/media/marker.6b9fc3e1.png";